import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "fr" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt3 fl" }, "CSVファイルをダウンロード", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { class: "w100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuggestedRoomsMembersHeader = _resolveComponent("SuggestedRoomsMembersHeader")!
  const _component_SuggestedRoomsMembersTable = _resolveComponent("SuggestedRoomsMembersTable")!
  const _component_FixVotedRoomsModal = _resolveComponent("FixVotedRoomsModal")!
  const _component_ChangeMemberInfoModal = _resolveComponent("ChangeMemberInfoModal")!
  const _component_ImportFromCalendarModal = _resolveComponent("ImportFromCalendarModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "skyblue pointer fs12 centered mb10 fr",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadCSV && _ctx.downloadCSV(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/download.png`),
          width: "16",
          height: "18",
          style: {},
          class: "mr2 fl"
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _hoisted_5
      ]),
      _hoisted_6
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_SuggestedRoomsMembersHeader, {
        onClickFormMember: _ctx.clickFormMember,
        onGoRoom: _ctx.goRoom,
        onChangeMemberInfo: _ctx.changeMemberInfo,
        onChangeCopyIfFix: _ctx.changeCopyIfFix,
        showRoomModal: _ctx.showRoomModal,
        showMenuModal: _ctx.showMenuModal
      }, null, 8, ["onClickFormMember", "onGoRoom", "onChangeMemberInfo", "onChangeCopyIfFix", "showRoomModal", "showMenuModal"])
    ]),
    _createVNode(_component_SuggestedRoomsMembersTable, { onConfirmDate: _ctx.confirmDate }, null, 8, ["onConfirmDate"]),
    _createVNode(_component_FixVotedRoomsModal, {
      ref: "FixVotedRoomsModal",
      room: _ctx.Util.isPresent(_ctx.vrm.rooms) ? _ctx.vrm.rooms[0] : null,
      isPreview: false,
      onFixedAppo: _ctx.fixedAppo,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["room", "onFixedAppo", "onClickCancel"]),
    _createVNode(_component_ChangeMemberInfoModal, {
      room: _ctx.currentRoom,
      member: _ctx.member,
      onUpdateMemberInfo: _ctx.updateMemberInfo
    }, null, 8, ["room", "member", "onUpdateMemberInfo"]),
    _createVNode(_component_ImportFromCalendarModal, { room: _ctx.room }, null, 8, ["room"])
  ]))
}